import { createGenericStore } from '@/stores/utils/genericStore.js' // Assumes genericStore.js is in your main app's 'resources/js/utils/'
import axios from 'axios'

// 1. Define your custom options
const userManagerStoreOptions = {
  state: () => ({
    // Add custom state properties here
    // e.g., customPropertyExample: null
  }),

  // Custom getters
  getters: {
    // e.g., myCustomGetter(state) { return ... }
  },

  // Custom actions
  actions: {
    // e.g., async myCustomAction() { ... }
    async fetchItems(params) {
      this.isLoading = true
      this.error = null
      const paramsInitial = {
        page: this.page,
        per_page: this.perPage,
        order_by: this.orderBy,
        order_direction: this.orderDirection,
        clear: true,
        ...this.filterByField ? { search_by_field: this.filterByField } : {},
        ...this.filterValue ? { search: this.filterValue } : {},
        ...this.searchQuery ? { search: this.searchQuery } : {}
      }
      params = { ...paramsInitial, ...params }

      try {
        const endpoint = params.search ? `${this.api}/search` : this.api
        const { data } = await axios.get(endpoint, { params })
        const items = data.data || data

        if (params && params.clear) {
          this.items = items
        } else {
          for (const item of items) {
            this.itemPatchState(item)
          }
        }

        if (data.current_page) {
          this.page = data.current_page
          this.perPage = data.per_page
          this.total = data.total
          this.lastPage = data.last_page
        } else if (data.meta) {
          this.page = data.meta.current_page
          this.perPage = data.meta.per_page
          this.total = data.meta.total
          this.lastPage = data.meta.last_page
        }

        return data
      } catch (err) {
        this.error = err
        console.error('Error fetching users:', err)
        throw err
      } finally {
        this.isLoading = false
      }
    },
    async setRolesForUser(id, roles_ids) {
      this.isLoading = true
      this.error = null
      try {
        const { data } = await axios.post(`${this.api}/${id}/roles`, roles_ids)
        this.itemPatchState(data)
        return data
      } catch (err) {
        this.error = err
        console.error(`Error patching item ${id}:`, err)
        throw err
      } finally {
        this.isLoading = false
      }
    }
  }
}

// 2. Create the store hook using your generic factory
export const useUserManagerStore = createGenericStore(
  'user-manager', // Base Store ID
  '/api/v1/users', // API Endpoint
  userManagerStoreOptions // Pass in your custom logic
)
